export interface ServiceCallsResponse {
    nextPage: string;
    totalCount: number;
    filteredCount: number;
    filterHTML: string;
    debug: number;
    items: ServiceCallItem[] | null;
}

export interface ServiceCallItem {
    notificationType: string;
    fullMachineName: string | null;
    status: ServiceCallStatus | null;
    sisCaseId: string;
    detailLink: string;
    lastUpdateFromSis: string;
    creationDate: string;
    createdByUser: string;
    description: string;
}

export interface ServiceCallStatus {
    type: ServiceCallStatusType;
    text: string;
}

export enum ServiceCallStatusType {
    TransactionFailed = "TransactionFailed",
    Open = "Open",
    Deleted = "Deleted",
    Closed = "Closed",
    WaitingForCustomer = "WaitingForCustomer",
    InProcess = "InProcess",
    CallPredictive = "call-predictive",
    UnreadChatMessages = "UnreadChatMessages",
    OrderNumberRequired = "OrderNumberRequired",
}
